const getFileNameFromFileRef = (fileRef: string): string => {
  const marker = '/';
  const markerIndex = fileRef.indexOf(marker);

  if (markerIndex === -1) {
    return fileRef;
  }

  return fileRef.slice(markerIndex + marker.length);
};

export const isVehicleAssetFileRef = (
  fileRef: string,
  vehicleId: string,
  containerName: string,
): boolean => {
  const fileName = getFileNameFromFileRef(fileRef);

  return fileName.startsWith(vehicleId) && fileRef.includes(containerName);
};
